import { css } from 'styled-components';
import { ScrollbarThemeColor, scrollbarThemes } from './scrollbar.theme';

/**
 *
 * @param themeColor The backgroundColor of the element that the scrollbar is on.
 * @param width
 * @returns
 */

export function getScrollbarStylingCss(themeColor: ScrollbarThemeColor, width?: 'auto' | 'thin') {
  return css`
    /* Firefox */
    scrollbar-width: ${width ?? 'auto'};
    scrollbar-color: ${scrollbarThemes[themeColor].thumb.normal} ${scrollbarThemes[themeColor].track};

    /* Chrome, Edge, and Safari */
    ::-webkit-scrollbar {
      width: ${width === 'thin' ? 4 : 8}px;
      height: ${width === 'thin' ? 4 : 8}px;
    }

    ::-webkit-scrollbar-track {
      background: ${scrollbarThemes[themeColor].track};
    }

    ::-webkit-scrollbar-thumb {
      background: ${scrollbarThemes[themeColor].thumb.normal};
    }

    ::-webkit-scrollbar-thumb:hover {
      background: ${scrollbarThemes[themeColor].thumb.hover};
    }
  `;
}
